import { render, staticRenderFns } from "./DataView.vue?vue&type=template&id=5445938e"
import script from "./DataView.vue?vue&type=script&lang=ts"
export * from "./DataView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports